var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarranty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8429 0.603392C33.0183 0.572307 33.198 0.572307 33.3733 0.603392L40.6794 1.89825C41.3725 2.02107 41.8754 2.6012 41.8754 3.27772V10.9133C41.8754 13.6888 40.3715 16.2682 37.903 17.6901L33.8599 20.019C33.3972 20.2855 32.8191 20.2855 32.3563 20.019L28.3133 17.6901C25.8447 16.2682 24.3408 13.6888 24.3408 10.9133V3.27772C24.3408 2.6012 24.8438 2.02107 25.5368 1.89825L32.8429 0.603392Z",
    fill: "url(#paint0_linear_201_380)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4188 3.45676L22.8792 4.24406V7.20137L19.9568 6.26618L6.23089 10.6585L19.9568 17.2469L24.0152 15.2989C24.4798 16.1397 25.078 16.9111 25.793 17.5822L21.418 19.6821V36.1843L36.0302 29.1705V20.4037L38.6544 18.8921C38.7552 18.834 38.8546 18.7744 38.9526 18.7131V30.0374C38.9526 30.5688 38.6399 31.0544 38.1448 31.292L20.6102 39.7086C20.1989 39.9061 19.7146 39.9061 19.3033 39.7086L1.76868 31.292C1.27364 31.0544 0.960938 30.5688 0.960938 30.0374V10.3986C0.960938 9.79482 1.3634 9.25877 1.96007 9.06784L19.4947 3.45676C19.7946 3.36077 20.119 3.36077 20.4188 3.45676ZM10.4213 23.9344C10.8521 23.6788 11.39 23.6556 11.8429 23.8731L16.2266 25.9772C16.7216 26.2148 17.0343 26.7005 17.0343 27.2318V31.4401C17.0343 31.9263 16.772 32.3778 16.3413 32.6335C15.9105 32.8891 15.3726 32.9122 14.9197 32.6948L10.536 30.5906C10.0409 30.353 9.72824 29.8674 9.72824 29.336V25.1277C9.72824 24.6415 9.99046 24.1901 10.4213 23.9344Z",
    fill: "url(#paint1_linear_201_380)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_380",
    x1: 19.3393,
    y1: 4.79777,
    x2: 39.5572,
    y2: 22.8495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE6684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_201_380",
    x1: -9.87567,
    y1: 11.2176,
    x2: 27.8818,
    y2: 50.5483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE6684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB8E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.c08b5aa3aec1b6740625c2e3818e3930.svg";
export { ForwardRef as ReactComponent };